module.exports = {
          srcSet: __webpack_public_path__ + "1b8f55139017cd54679af9168856dae6-66.png"+" 66w",
          images:[ {path: __webpack_public_path__ + "1b8f55139017cd54679af9168856dae6-66.png",width: 66,height: 15}],
          src: __webpack_public_path__ + "1b8f55139017cd54679af9168856dae6-66.png",
          toString:function(){return __webpack_public_path__ + "1b8f55139017cd54679af9168856dae6-66.png"},
          
          width: 66,
          height: 15
        }